import { render, staticRenderFns } from "./HoldingRepurchaseTable.vue?vue&type=template&id=758a8d78&"
import script from "./HoldingRepurchaseTable.vue?vue&type=script&lang=js&"
export * from "./HoldingRepurchaseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports